<template>
  <esg-base-dashboard-card :grid="true"
                           title="협력사 배출량 상세정보">
    <template #actions>
      <b-col cols='12'>
        <b-row align-h='end'>
          <b-form-group
              content-cols="auto"
              class="mb-0 mr-3 text-nowrap">
            <b-input-group size="sm">
              <b-form-select v-model="selectedBusinessLoc"
                             size="sm">
                <option :disabled="true"
                        :value="'all'">주거래 사업장
                </option>
                <option :value="'all'">ALL</option>
                <option v-for="option in mainBizLocOptions"
                        :key="option"
                        :value="option">{{ option }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-row>
      </b-col>
    </template>
    <esg-table-without-meta size="xs"
                            :fields="fields"
                            :items="items">
      <template #thead-top>
        <tr>
          <th colspan="3"><span>협력사 정보</span></th>
          <th colspan="7"><span>배출량 관리</span></th>
          <th colspan="2"><span>LCA</span></th>
          <th colspan="1"><span>그래프</span></th>
        </tr>
      </template>
      <template #cell(recent_five_years)="data">
        <td class="m-1"
            style="height: 40px">
          <apex-chart width="100"
                      height="35"
                      :options="chartOptions"
                      :series="[{ data: data.value }]"/>
        </td>
      </template>
      <template #cell(total_emission)="{ value }">
        <td>{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(total_emission_diff)="{ item, value }">
        <td>
            <span class="diff py-0 text-nowrap"
                  :class="{ 'diff-up': value >= 0, 'diff-down': value < 0 }">
              {{ value >= 0 ? '▲' : '▼' }}
              {{
                `${Math.abs(value).toLocaleString('ko-KR')} (${(100 * Math.abs(value) / item.total_emission).toFixed(2)
                }%)`
              }}
            </span>
        </td>
      </template>
      <template #cell(upstream_emission)="{ value }">
        <td class="text-center">{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(downstream_emission)="{ value }">
        <td class="text-center">{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(revenue)="{ value }">
        <td class="text-center">{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(emission_per_unit_revenue)="{ value }">
        <td class="text-center">{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(emission_per_unit_revenue_diff)="{ item, value }">
        <td class="text-center">
            <span class="diff py-0 text-nowrap"
                  :class="{ 'diff-up': value >= 0, 'diff-down': value < 0 }">
              {{ value >= 0 ? '▲' : '▼' }}
              {{
                `${Math.abs(value).toLocaleString('ko-KR')} (${(100 * Math.abs(value) /
                    item.emission_per_unit_revenue).toFixed(2)}%)`
              }}
            </span>
        </td>
      </template>
      <template #cell(number_of_products)="{ value }">
        <td class="text-center">{{ value.toLocaleString('ko-KR') }}</td>
      </template>
      <template #cell(affiliated)="{ value }">
        <td class="text-center">{{ value ? 'O' : 'X' }}</td>
      </template>
    </esg-table-without-meta>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: {EsgTableWithoutMeta, EsgBaseDashboardCard},
  data() {
    return {
      selectedBusinessLoc: 'all',
      chartOptions: {
        chart: {
          type: 'line',
          sparkline: {
            enabled: true
          }
        },
        stroke: {
          show: true,
          curve: 'straight',
          lineCap: 'butt',
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
        tooltip: {
          fixed: {
            enabled: false
          },
          x: {
            show: false
          },
          y: {
            title: {
              formatter: () => ''
            }
          },
          marker: {
            show: false
          }
        }
      },
      items: [
        {
          partner_code: '2022-001',
          partner_name: 'EY 정공',
          main_business_location: '울산 고무 공장',
          total_emission: 1275,
          total_emission_diff: 35,
          upstream_emission: 1275,
          downstream_emission: 0,
          revenue: 13298,
          emission_per_unit_revenue: 456,
          emission_per_unit_revenue_diff: -200,
          affiliated: true,
          number_of_products: 4,
          recent_five_years: [5, -2, 3, -5, 9]
        },
      ],
      fields: [
        {
          name: "partner_code",
          label: "관리 코드",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "partner_name",
          label: "협력사명",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "main_business_location",
          label: "주거래 사업장",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "total_emission",
          label: "총배출량",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "total_emission_diff",
          label: "전년비",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "upstream_emission",
          label: "업스트림 배출량",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "downstream_emission",
          label: "다운스트림 배출량",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "revenue",
          label: "공급가액(천원)",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "emission_per_unit_revenue",
          label: "만원당 배출량",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "emission_per_unit_revenue_diff",
          label: "전년비",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "affiliated",
          label: "협력여부",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "number_of_products",
          label: "협력 제품수",
          class: ["text-center", "align-middle"],
          list: true,
          sortable: true
        },
        {
          name: "recent_five_years",
          label: "최근 5개년 비교",
          list: true,
          class: ["text-center", "align-middle"]
        }
      ]
    }
  },
  computed: {
    mainBizLocOptions() {
      return this.items.map(obj => obj.main_business_location);
    }
  },
}
</script>

<style scoped>
#esg-partner-data-grid .table-wrapper {
  overflow-x: scroll;
  white-space: pre;
}

#esg-partner-data-grid .table-wrapper table {
  width: auto;
  min-width: 100%;

}

#esg-partner-data-grid .b-table-sticky-header > .table.b-table > thead {
  position: sticky !important;
  top: 0;
  z-index: 2;
}

#esg-partner-data-grid .b-table-sticky-header > .table.b-table > thead > tr > th {
  text-align: center;
  border: 1px solid #C4C4CD;
  background-color: #F6F6FA;
  border-collapse: collapse;
}

#esg-partner-data-grid >>> .table thead th {
  font-size: 0.75rem !important;
  background-color: #F6F6FA;
  border-color: #C4C4CD;
}

#esg-partner-data-grid >>> .table tbody td {
  font-size: 0.75rem !important;
  border-color: white;
}

#esg-partner-data-grid >>> .table {
  margin-bottom: 0
}

#esg-partner-data-grid .diff {
  border-radius: .5rem;
  padding: 4px;
  font-size: .75rem;
}

#esg-partner-data-grid .diff.diff-up {
  background-color: #93e4c1;
}

#esg-partner-data-grid .diff.diff-down {
  background-color: #e46161;
}
</style>
